export type SoundProfileName = 'permissionRequest' | 'planApproval' | 'questionnaire' | 'agentReply'

export interface ToneSpec {
  readonly frequency: number
  readonly durationSeconds: number
}

export interface SoundProfile {
  readonly tones: ReadonlyArray<ToneSpec>
  readonly gapSeconds: number
  readonly volume: number
  readonly fadeOutSeconds: number
}

// permissionRequest: two-tone ascending knock (660 Hz → 880 Hz)
const PERMISSION_REQUEST: SoundProfile = {
  tones: [
    { frequency: 660, durationSeconds: 0.1 },
    { frequency: 880, durationSeconds: 0.1 },
  ],
  gapSeconds: 0.02,
  volume: 0.3,
  fadeOutSeconds: 0.08,
}

// planApproval: lower single tone conveying gravitas
const PLAN_APPROVAL: SoundProfile = {
  tones: [{ frequency: 550, durationSeconds: 0.4 }],
  gapSeconds: 0,
  volume: 0.3,
  fadeOutSeconds: 0.4,
}

// questionnaire: three quick blips
const QUESTIONNAIRE: SoundProfile = {
  tones: [
    { frequency: 880, durationSeconds: 0.06 },
    { frequency: 880, durationSeconds: 0.06 },
    { frequency: 880, durationSeconds: 0.06 },
  ],
  gapSeconds: 0.05,
  volume: 0.3,
  fadeOutSeconds: 0.05,
}

// agentReply: unchanged legacy single tone
const AGENT_REPLY: SoundProfile = {
  tones: [{ frequency: 880, durationSeconds: 0.3 }],
  gapSeconds: 0,
  volume: 0.3,
  fadeOutSeconds: 0.3,
}

export const SOUND_PROFILES: Readonly<Record<SoundProfileName, SoundProfile>> = {
  permissionRequest: PERMISSION_REQUEST,
  planApproval: PLAN_APPROVAL,
  questionnaire: QUESTIONNAIRE,
  agentReply: AGENT_REPLY,
}

const EVENT_TYPE_TO_PROFILE: Readonly<Record<string, SoundProfileName>> = {
  TOOL_PERMISSION_REQUEST: 'permissionRequest',
  PLAN_APPROVAL_REQUEST: 'planApproval',
  AGENT_QUESTIONS: 'questionnaire',
  AGENT_REPLY: 'agentReply',
}

export function profileForEventType(eventType: string): SoundProfileName {
  return EVENT_TYPE_TO_PROFILE[eventType] ?? 'agentReply'
}
